import type { OuScope } from '@/api/types';

interface ScopedUser {
  ouScope: OuScope;
  recognitionOuScope: OuScope;
}

/**
 * Deja en el filtro de OU solo las OUs que el servidor le deja ver a quien usa la pantalla (espejo de
 * `RecognitionScopeGuard.GetUsersManagementScope`): sin restricción en alguno de los dos alcances = todas; si no, la unión
 * de las OUs delegadas de Pulso y de Reconocimiento. El servidor es quien acota de verdad; esto solo evita ofrecer OUs
 * que devolverían una lista vacía. Sin perfil resuelto no se recorta nada.
 */
export function scopedOuItems<T extends { id: string }>(items: readonly T[], user: ScopedUser | null): readonly T[] {
  if (!user) return items;
  if (user.ouScope.allOusAccess || user.recognitionOuScope.allOusAccess) return items;
  const allowed = new Set([...user.ouScope.rootOuIds, ...user.recognitionOuScope.rootOuIds].map(id => id.toLowerCase()));
  return items.filter(item => allowed.has(item.id.toLowerCase()));
}
